import { Box } from '@mui/material';
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { fetchStages, setOwner, setStage } from 'store/slices/dealsSlice';
import Details from './Details';
import Header from './Header';

const DealDetailsMain = () => {
  const dispatch = useAppDispatch();
  const { pipelineType, stageName, ownerName } = useAppSelector((state) => state.deals.deal);

  useEffect(() => {
    const fetchOwners = async () => {
      try {
        await dispatch(fetchStages(pipelineType));
      } catch (error) {
        console.error(error);
      }
    };

    fetchOwners();
  }, [dispatch, pipelineType]);

  useEffect(() => {
    if (stageName) dispatch(setStage(stageName));
    if (ownerName) dispatch(setOwner(ownerName));
  }, [dispatch, stageName, ownerName]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100vh - 90px)',
        overflow: 'hidden',
      }}
    >
      <Header />
      <Box sx={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
        <Details />
      </Box>
    </Box>
  );
};

export default DealDetailsMain;
